"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourcesComparison = exports.ResourceRowSchema = void 0;
const z = require("zod");
const value_comparison_1 = require("../../Comparison/value-comparison");
const comparison_spec_1 = require("../comparison-spec");
exports.ResourceRowSchema = z.object({
    name: z.string(),
    mustBeConsumed: z.boolean(),
    conditions: z.string(),
    sourceConditions: z.unknown().optional(),
});
class ResourcesComparison extends comparison_spec_1.ComparisonSpec {
    constructor() {
        super(...arguments);
        this.alignment = new comparison_spec_1.CellAlignment(['name'], ['mustBeConsumed', 'conditions']);
    }
    toRows(data) {
        return data;
    }
    fromRows(rows) {
        return rows;
    }
    rowKeyOf(row) {
        return (0, value_comparison_1.compositeKey)(row, this.alignment.keyColumns.map(String), (column, value, rowContext) => this.normalize(column, value, rowContext));
    }
}
exports.ResourcesComparison = ResourcesComparison;
//# sourceMappingURL=resources.comparison.js.map